import Vue from 'vue'
import gridInput from './GridInput.vue'
Vue.component('grid-input', gridInput)
